import { takeLatest, put, call, select } from 'redux-saga/effects';
import ProductActions, { ProductTypes } from '../Redux/ProductRedux';
import ApiResponseError from '../Services/ApiResponseError';

export function * getProducts(api, {query}) {
    try {
        const response = yield call(api.getProductCollection, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }

        const data = response.data.data;
        const pagination = data.pagination ? data.pagination : null;

        yield put(ProductActions.fetchProductsSuccess(data.products, pagination));
    } catch (e) {
        yield put(ProductActions.fetchProductsFailure(e));
    }
}

export function * createProduct(api, {product, query}) {
    try {
        const response = yield call(api.postProductCollection, product);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(ProductActions.createProductSuccess(response.data.data.product));
    } catch (e) {
        yield put(ProductActions.createProductFailure(e));
    }
}

export function * getProduct(api, {uuid, query}) {
    try {
        const response = yield call(api.getProductResource, uuid, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(ProductActions.fetchProductSuccess(response.data.data.product));
    } catch (e) {
        yield put(ProductActions.fetchProductFailure(e));
    }
}

export function * updateProduct(api, {uuid, product, query}) {
    try {
        const response = yield call(api.patchProductResource, uuid, product, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(ProductActions.updateProductSuccess(response.data.data.product));
    } catch (e) {
        yield put(ProductActions.updateProductFailure(e));
    }
}

export function * deleteProduct(api, {uuid, query}) {
    try {
        const response = yield call(api.deleteProductResource, uuid, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(ProductActions.deleteProductSuccess());
        yield call(getProducts, api, {query});
    } catch (e) {
        yield put(ProductActions.deleteProductFailure(e));
    }
}

export function * watchProduct(api) {
    yield takeLatest(ProductTypes.FETCH_PRODUCTS, getProducts, api);
    yield takeLatest(ProductTypes.CREATE_PRODUCT, createProduct, api);
    yield takeLatest(ProductTypes.FETCH_PRODUCT, getProduct, api);
    yield takeLatest(ProductTypes.UPDATE_PRODUCT, updateProduct, api);
    yield takeLatest(ProductTypes.DELETE_PRODUCT, deleteProduct, api);

    yield takeLatest(ProductTypes.CREATE_PRODUCT_SUCCESS, getProducts, api);
}



// WEBPACK FOOTER //
// ./src/Sagas/ProductSagas.js